import { AppConfig } from './app.config';
import { environment } from '../environments/environment';
import { AppRequestOptions } from './app.request-options';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { APP_INITIALIZER } from '@angular/core';


export function appConfigFactory(appConfig: AppConfig) {
  return () => appConfig.loadAppConfig();
}


export const APP_PROVIDERS = [
  AppConfig,
  {
    provide: APP_INITIALIZER,
    useFactory: appConfigFactory,
    deps: [AppConfig],
    multi: true,
  },
];
